export default "__VITE_ASSET__LGr8RJP3__"